<template>
  <div class="get-today">
    <DefLinkBrown :disabled="product?.isPair && !isPairSelected" @click="handlerOpenModal">
      <svg class="get-today-button__icon">
        <use xlink:href="#svg-calendar"></use>
      </svg>
      {{ messages.getToday }}
    </DefLinkBrown>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DefLinkBrown from '@components/Def/DefLink/DefLinkBrown.vue';
import useModalAside from '@use/useModalAside/useModalAside';
import GetTodayModal from '@components/Product/GetToday/GetTodayModal.vue';

export default {
  name: 'GetToday',
  components: { DefLinkBrown },
  props: ['result', 'messages'],
  data() {
    return {
      modalAside: useModalAside(),
    };
  },
  computed: {
    ...mapState({
      isPairSelected: ({ product }) => product?.data?.isPairSelected,
      product: ({ product }) => product?.data?.product,
    }),
  },
  methods: {
    handlerOpenModal() {
      this.modalAside.show(GetTodayModal);
    },
  },
};
</script>

<style lang="scss" scoped>
.get-today {
  :deep(.def-slide-modal__block) {
    padding: 40px 6px 24px 16px;
    @include point-md {
      padding: 36px 14px 32px 24px;
    }
    @include point-lg {
      padding: 68px 40px 60px 60px;
    }
  }
  :deep(.def-link-brown) {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-transform: uppercase;
    svg {
      fill: currentColor;
      width: 18px;
      height: 18px;
      flex-shrink: 0;
    }
  }
}
</style>
